import { FiltersBar, SearchInput, useFilterUpdate } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useOrderListFilter } from './useOrderListFilter';

export function Filters() {
  const { search, setSearch } = useOrderListFilter();
  const { t } = useTranslation();

  useFilterUpdate('search', search);

  return (
    <FiltersBar.Row>
      <SearchInput
        placeholder={t('transportOrders.list.searchPlaceholder')}
        onChange={v => setSearch(v)}
        defaultValue={search}
      />
    </FiltersBar.Row>
  );
}
